import type { ILocationV2 } from '@sravni/types/lib/locations';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_USER_REGION } from '../../constants/locations';

export interface IState {
  currentUserLocation: ILocationV2;
}

const initialState: IState = {
  currentUserLocation: DEFAULT_USER_REGION,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setCurrentUserLocation: (state, { payload }: PayloadAction<ILocationV2>) => {
      state.currentUserLocation = payload;
    },
  },
});

const { actions, reducer } = locationSlice;

export const { setCurrentUserLocation } = actions;

export default reducer;
